import React, { useEffect, useState, useRef } from "react";
import { getStoreProducts } from './../../../apis/requests';
import Product from "../products/Product";
import { Toast } from "primereact/toast";
import { useTranslation } from "react-i18next";
import { DataView } from 'primereact/dataview';
import { Paginator } from "primereact/paginator";
import ShopFilters from './shop/ShopFilters';
import { useParams } from "react-router-dom";
import ShopLoader from './shop/loaders/ShopLoader';
const Shop = () => {
    const { t } = useTranslation();
    const toast = useRef();
    const params = useParams();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [first, setFirst] = useState(1);
    const [rows, setRows] = useState(12);
    useEffect(() => {
        loadStoreProducts();
    }, [params]);
    const loadStoreProducts = async (page = 1, search = params.query) => {
        try {
            let data = {
                page: page,
                per_page: 12,
                type: params.type,
                id: params.id,
                search: search,
                sort: params.name,
            }
            setLoading(true);
            const res = await getStoreProducts(data);
            setProducts(res.data.data);
            setTotalRecords(res.data.pagination.total);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    }
    const listTemplate = (items) => {
        let list = items.map((product) => {
            return itemTemplate(product);
        });
        return <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2">{list}</div>;
    };

    const itemTemplate = (product) => {
        return (
            <Product
                showSortType={params.name !== undefined && params.type === undefined}
                sortType={params.name}
                item={product}
                showToast={() => {
                    toast.current.show({ severity: 'success', detail: t('item_added_to_cart'), life: 3000 });
                }}
            />
        );
    };
    return (
        <div className="">

            {
                params.type !== undefined &&
                <div className="bg-[#003030] p-4 mt-[5px]">
                    <span className="text-white">{t('shop')} / {t(params.type)} / <span className="font-semibold"> {params.name}</span></span>
                </div>
            }
            {
                params.query !== undefined &&
                <div className="bg-[#003030] p-4 mt-[5px]">
                    <span className="text-white">{t('shop')} / {t('search')} /  <span className="font-semibold">{params.query}</span></span>
                </div>
            }
            {
                (params.name !== undefined && params.type === undefined) &&
                <div className="bg-[#003030] p-4 mt-[5px]">
                    <span className="text-white">{t('shop')} /  <span className="font-semibold">{t(params.name)}</span></span>
                </div>

            }

            <div className="grid grid-cols-12">
                <div className="lg:block hidden lg:col-span-3">
                    <div className="mt-4 mx-8">
                        <ShopFilters filterId={params.id} filterType={params.type} />
                    </div>
                </div>
                <div className="lg:col-span-9 col-span-12">
                    {
                        loading &&
                        <ShopLoader />
                    }
                    {
                        !loading &&
                        <div className="mx-4">

                            <DataView value={products} listTemplate={listTemplate} />
                            <Paginator
                                first={first}
                                rows={rows}
                                totalRecords={totalRecords}
                                onPageChange={(e) => {
                                    setFirst(e.first);
                                    setRows(e.rows);
                                    loadStoreProducts(e.page + 1, params.query);
                                }}
                            />
                        </div>
                    }
                </div>
            </div>
            <Toast ref={toast}
                position="bottom-center"
            />

        </div>
    );
}
export default Shop;